import { Bar, mixins } from "vue-chartjs";
export default {
  extends: Bar,
  props: [ 'options'],
  mixins: [mixins.reactiveProp],
  data: () => ({
    updating: false,
  }),
  watch: {
    // 'data': {
    //   deep: true,
    //   handler() {
    //     if (!this.updating && this.$data && this.$data._chart) {
    //       this.updating = true;
    //       // this.renderChart(this.data, this.options);
    //       this.$data._chart.update();
    //       this.$nextTick(() => this.updating = false);
    //     }
    //   }
    // },
    'options': {
      deep: true,
      tooltips: {
        xAlign: 'left',
        yAlign: 'center'
      },
      handler() {
        if (!this.updating && this.$data && this.$data._chart) {
          this.updating = true;
          // this.renderChart(this.data, this.options);
          this.$data._chart.options = this.options;
          this.$data._chart.update();
          this.$nextTick(() => this.updating = false);
        }
      }
    },
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};
